import { useMemo } from 'react';
import { useAppSelector } from '.';
const useShouldShowDemoExitConfirmationComponent = () => {
  const {
    isInDemoApp,
    isVerticalNavEnabled
  } = useAppSelector(state => state.appConfig);
  return useMemo(() => ({
    shouldShowDemoExitConfirmationComponent: isVerticalNavEnabled && isInDemoApp
  }), [isInDemoApp, isVerticalNavEnabled]);
};
export default useShouldShowDemoExitConfirmationComponent;